import { createFileRoute, Outlet } from "@tanstack/react-router";

const NoSidebarLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_authed/_noSidebar")({
  component: NoSidebarLayout,
});
